/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
import { authHeaders } from '../services/auth'
Vue.use(VueResource);

Vue.http.options.root = process.env.API_URL;

/**
 * Every authenticated request will return an access token and client that we want to store/update
  - **access-token**: _dKG2WG4AwcCZpPCHf-GyQ
  - **client**: hHcKpvm0KCbZjihE3ZVlCA
  - **uid**
  1. update access token and client on every response
  2. include headers with each outgoing request with latest token/response
 */

Vue.http.interceptors.push((request, next) => {
  // Add access token to request
  // console.log('Upgrading headers...');

  // Before we send a request we add stored auth headers:
  // console.log('adding headers...')
  authHeaders.forEach((headerItem) => {
    if( !request.headers.hasOwnProperty(headerItem)) {
      let storedVal = localStorage.getItem(headerItem);
      if(storedVal) request.headers.set(headerItem, storedVal);
    }
  })

  // console.log(request.headers);

  next((response) => {
    // console.log('saving new headers...');
    // When we receive a request with new values, we update stored auth properties
     console.log(response);
    /*authHeaders.forEach((headerItem) => {
      let val = response.headers.get(headerItem);

      // #todo. not sure if we should null the values or retain previous values until logout is called
      // if we null them a server error or timeout might log a user out by accident
      if( !val) return;

      // console.log(`${headerItem}=${val}`);
      localStorage.setItem(headerItem, val);
    })*/
  });
})


// WEBPACK FOOTER //
// ./src/resources/configure.js